// Import helpers
import { fetchSubscriberAgreements } from 'helpers/api/agreements';

// Import types
import type { SubscriberAgreementsType, ConfirmedSubscriberAgreementsType } from 'types/api/agreements';

export const getConfirmedAgreementVersions = (agreements: SubscriberAgreementsType, agreementsTypes: string[]) => {
	const confirmed = agreements.filter(
		({ type, subscriber_agreement }) => agreementsTypes.includes(type) && subscriber_agreement?.confirmed
	) as ConfirmedSubscriberAgreementsType;

	return confirmed.map(({ subscriber_agreement }) => subscriber_agreement.agreement_version_id);
};

export const fetchDefaultValues = (agreementsIds: number[], agreementsTypes: string[]) => async () => {
	try {
		const agreement_version_ids = await fetchSubscriberAgreements().then((agreements) => getConfirmedAgreementVersions(agreements, agreementsTypes));
		const all = agreementsIds.every((id) => agreement_version_ids.includes(id));
		return { agreement_version_ids, all };
	} catch (error) {
		return { agreement_version_ids: [], all: false };
	}
};
